import styled from 'styled-components';

import Img from 'components/Img';

const StyledImg = styled(Img)`
  width: 100%;
  height: 100%;

  &&& div {
    background-size: 100% 100%;
  }
`;

StyledImg.defaultProps = {
};

export default StyledImg;
